import styles from "../landing-page-four.module.css";
import { useCheckoutPricing } from "hooks/use-checkout-pricing";

interface InstructionsSectionProps {
  onClick: () => void;
}

export const InstructionsSection = (props: InstructionsSectionProps) => {
  const { formattedPriceForProject } = useCheckoutPricing();

  return (
    <div className={styles.sectionContainer}>
      <h1 className={styles.sectionTitle}>How it works</h1>
      <div className={styles.instructionPanelsContainer}>
        <button className={styles.instructionPanel}>
          <div className={styles.instructionNumber}>1</div>
          <h3>Choose a design</h3>
          <p>From our gallery of dozens of carefully crafted preset designs</p>
        </button>
        <button className={styles.instructionPanel} onClick={props.onClick}>
          <div className={styles.instructionNumber}>2</div>
          <h3>Customise</h3>
          <p>
            Add your own activity GPS route (we'll show you how!)
            <br />
            <br />
            Tweak anything from <b>map style</b> to <b>fonts</b> and{" "}
            <b>route line style</b>
          </p>
        </button>
        <button className={styles.instructionPanel} onClick={props.onClick}>
          <div className={styles.instructionNumber}>3</div>
          <h3>Order</h3>
          <p>
            Choose from a variety of sizes at design time. Printed on a premium
            aluminuim dibond substrate with vibrant colors. finish, from just{" "}
            {formattedPriceForProject()}.
          </p>
          <div className={styles.priceBadge}>
            <div className={styles.priceBadgeFrom}>from</div>
            <div className={styles.priceBadgePrice}>
              {formattedPriceForProject()}
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};
